<template>
  <div>
    <el-table :data="currencyIntroductionList" height="calc(100vh - 300px)">
      <el-table-column prop="coin" label="币种" />
      <el-table-column prop="actualPrecision" label="实际精度" />
      <el-table-column prop="displayPrecision" label="显示精度" />
      <el-table-column prop="" label="是否可划转">
        <template slot-scope="scope">
          <span>{{ scope.row.isExchange ? "可用" : "不可用" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="是否可用">
        <template slot-scope="scope">
          <span>{{ scope.row.isOpen ? "可用" : "不可用" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coin" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createdTime | moment }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            size="small"
            @click="handleEdit(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="size"
      :page="page"
      :total="totalCount"
      @pageChanged="handlePageChanged"
    >
    </pagination>
    <el-dialog
      title="添加"
      width="600px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <el-form label-width="200px" :model="formData" :rules="rules" ref="form">
        <el-form-item label="币种：" prop="coin">
          <el-input v-model="formData.coin" style="width: 180px"></el-input>
        </el-form-item>

        <el-form-item label="实际精度：" prop="actualPrecision">
          <el-input-number
            :precision="0"
            :step="1"
            :min="0"
            v-model.trim="formData.actualPrecision"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="显示精度：" prop="displayPrecision">
          <el-input-number
            :precision="0"
            :step="1"
            :min="0"
            v-model.trim="formData.displayPrecision"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="是否可划转：" prop="isExchange">
          <el-switch
            v-model="formData.isExchange"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>

        <el-form-item label="是否可用：" prop="isOpen">
          <el-switch
            v-model="formData.isOpen"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave('form')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Pagination from "components/pagination";

export default {
  name: "CurrencyIntroductionList",
  data() {
    return {
      formData: {
        coin: "",
        actualPrecision: 0,
        displayPrecision: 0,
        isExchange: 0,
        isOpen: 0,
        id: "",
      },
      page: 1,
      size: 25,
      dialogVisible: false,
      rules: {
        coin: [{ required: true, message: "请输入币种名称", trigger: blur }],
        actualPrecision: [
          { required: true, message: "请输入实际精度", trigger: blur },
        ],
        displayPrecision: [
          { required: true, message: "请输入显示精度", trigger: blur },
        ],
      },
    };
  },
  components: {
    Pagination,
  },
  computed: {
    ...mapState("spotCoinAdminStore", [
      "currencyIntroductionList",
      "pagination",
      "totalCount",
    ]),
  },
  methods: {
    ...mapActions("spotCoinAdminStore", ["update"]),
    handlePageChanged(e) {
      this.page = e.page;
      this.size = e.size;
      this.$emit("refresh", { page: this.page, size: this.size });
    },
    handleEdit(row) {
      console.log("row", row);
      Object.keys(this.formData).forEach((i) => {
        this.formData[i] = row[i];
      });
      this.formData.isExchange == true
        ? (this.formData.isExchange = 1)
        : (this.formData.isExchange = 0);

      this.formData.isOpen == true
        ? (this.formData.isOpen = 1)
        : (this.formData.isOpen = 0);
      this.dialogVisible = true;
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.update(this.formData).then(() => {
            this.$message.success("添加成功！");
            this.dialogVisible = false;
            this.$emit("refresh", { page: 1 });
          });
        }
      });
    },
    closeDialog() {
      this.formData = {
        coin: "",
        actualPrecision: 0,
        displayPrecision: 0,
        isExchange: 0,
        isOpen: 0,
        id: "",
      };
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    },
    refreshList() {
      this.$emit("refresh");
    },
  },
};
</script>

<style lang="less" scoped></style>
